import React, {
  useState,
  useEffect,
  useCallback,
  useContext,
  memo,
} from "react";
import { useJsApiLoader } from "@react-google-maps/api";
import { Brands, Store } from "../types.d";
import MapContainer from "../components/map-container";
import PanelContainer from "../components/panel-container";
import { FindAStoreContext, FindAStoreProvider } from "../contexts/findAStore";

const googleLibraries: any = ["places"];

export interface FindAStoreLayoutProps {
  children?: JSX.Element | JSX.Element[];
  className?: string;
  hideMap?: boolean;
  pageContext?: {
    brands: Brands[];
    mapCenter: { lat: number; lng: number };
    mapZoom?: number;
    store?: Store;
    layout?: string;
    stores?: Store[];
  };
}

export const FindAStoreLayout = (props: FindAStoreLayoutProps) => {
  const { children, pageContext } = props;
  const {
    dispatch,
    state: { map },
  } = useContext(FindAStoreContext);
  useEffect(() => {
    dispatch({ type: "SetStores", payload: pageContext.stores });
  }, []);

  const [isBot, setIsBot] = useState<boolean>(
    /bot|google|baidu|bing|msn|duckduckbot|teoma|slurp|yandex/i.test(
      typeof navigator === "undefined" ? "" : navigator.userAgent
    )
  );
  const { isLoaded: googleLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: process.env.GATSBY_GOOGLE_API_KEY as string,
    libraries: googleLibraries,
  });

  return (
    <div
      sx={{
        flexGrow: 1,
        overflow: "hidden",
        display: "flex",
        position: "relative",
        color: "#383739",
      }}
      role="main"
    >
      <div
        sx={{
          flexGrow: 1,
          flex: "1 0 auto",
          display: "flex",
          flexDirection: ["column", null, null, "row-reverse"],
          width: "100%",
          height: "auto",
          backgroundColor: "white",
          "& .svg-inline--fa": {
            marginRight: "5px",
            marginLeft: "5px",
          },
        }}
      >
        <MapContainer
          googleLoaded={googleLoaded}
          isBot={isBot}
          setIsBot={setIsBot}
          hideMap={props.hideMap}
        />
        <PanelContainer
          googleLoaded={googleLoaded}
          isBot={isBot}
          setIsBot={setIsBot}
          brands={props.pageContext?.brands ?? ["SPEEDYCASH", "RAPIDCASH"]}
          store={props.pageContext?.store}
        />
      </div>
      {children}
    </div>
  );
};

export default FindAStoreLayout;
